export const MARKETS_WITH_CUSTOM_APR: Record<string, number> = {
  ['oeN7bBJAjFqnvFwALPBazEFJeTi9F6tLvKHhuoJjSkk']: 3380, //? ONE collection PUBLIC market
  ['2RSYRoqZ2bKnKGeLtGFyTmDLNEaV9Z9zhmZd5qXxAsr9']: 3380, //? ONE collection PRIVATE market
}
